import Common from '../../Common';
import UserData from './customerData/UserData';

const CustomerData = class extends Common {
	userData: InstanceType<typeof UserData>;

	constructor(headers: ApiHeaders) {
		super(headers)

		this.userData = new UserData(headers);
	}

	async read(companyId: id) {
		return this.get(`/company/${companyId}/customerdata`)
	}
}

export default CustomerData;
